import DashboardOverview from "./DashboardOverview";
import "./Dashboard.scss";

const Dashboard = () => {
  return <DashboardOverview />;
};
export default Dashboard;
